import React from 'react';
const LINES = [{
  label: 'La Guía de Transformación Corporal',
  value: '$47'
}, {
  label: 'Código de Recuperación',
  value: '$17'
}, {
  label: 'Guion de Consulta',
  value: '$17'
}, {
  label: 'Línea de Tiempo de Transformación',
  value: '$16'
}];
export function PricingAnchor() {
  return <section className="section" data-id="element-86">
      <h2 className="section-h2 section-h2--center" data-id="element-87">
        La composición del valor.
      </h2>

      <div className="price-breakdown" data-id="element-88">
        {LINES.map(line => <div key={line.label} className="price-line" data-id="element-89">
            <span className="price-line__label" data-id="element-90">{line.label}</span>
            <span className="price-line__leader" aria-hidden="true" data-id="element-91" />
            <span className="price-line__value" data-id="element-92">{line.value}</span>
          </div>)}

        <div className="price-line price-line--total" data-id="element-93">
          <span className="price-line__label" data-id="element-94">Valor del bundle</span>
          <span className="price-line__leader" aria-hidden="true" data-id="element-95" />
          <span className="price-line__value" data-id="element-96">$97</span>
        </div>

        <div className="price-line price-line--today" data-id="element-97">
          <span className="price-line__label" data-id="element-98">Hoy</span>
          <span className="price-line__leader" aria-hidden="true" data-id="element-99" />
          <span className="price-line__value" data-id="element-100">$17</span>
        </div>
      </div>

      <p className="price-coda" data-id="element-101">
        Antes de gastar miles en una transformación corporal, consigue claridad
        por $17. Una decisión de cinco cifras merece preparación.
      </p>

      <p className="price-finecoda" data-id="element-102">
        Sin suscripción · Sin renovación · Una vez · Para siempre
      </p>
    </section>;
}